import { render } from "./MagicLinkSend.vue?vue&type=template&id=5fbf3ca2&scoped=true"
import script from "./MagicLinkSend.vue?vue&type=script&lang=js"
export * from "./MagicLinkSend.vue?vue&type=script&lang=js"

import "./MagicLinkSend.vue?vue&type=style&index=0&id=5fbf3ca2&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbf3ca2"]])

export default __exports__